import type { CtaType } from '@repo/supergraph-schemas/marketplace/types';

export const stripFederallyInsuredAnnotation = (
  cta?: CtaType,
  federallyInsuredAnnotation?: string,
) => {
  if (!cta || !cta.subtext || !federallyInsuredAnnotation) return cta;

  const annotationPattern = `, ${federallyInsuredAnnotation}`;
  if (cta.subtext.endsWith(annotationPattern)) {
    return {
      ...cta,
      subtext: cta.subtext.slice(0, -annotationPattern.length),
    };
  }

  return cta;
};
